import { useEffect, useRef, useState, type RefObject } from 'react';

export const useStuckState = (rootRef: RefObject<HTMLElement | null>) => {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const rootTop = entry.rootBounds?.top ?? 0;

        setIsStuck(
          !entry.isIntersecting && entry.boundingClientRect.top < rootTop
        );
      },
      { root: rootRef.current, threshold: 0 }
    );

    observer.observe(sentinel);

    return () => observer.disconnect();
  }, [rootRef]);

  return { sentinelRef, isStuck };
};
